import { render, staticRenderFns } from "./ThousandMentorsModal.vue?vue&type=template&id=fbecd6aa&"
import script from "./ThousandMentorsModal.vue?vue&type=script&lang=js&"
export * from "./ThousandMentorsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports